<li *ngIf="bot">
  <!-- <a [href]="portalSettings.url + '/bot/' + bot.bot_id"> -->
  <a [routerLink]="['/bot', bot.bot_id, 'dashboard']">
    <img [src]="bot.image" alt="" class="nav-menu__image" />
    {{ bot.name }}
  </a>
</li>
